import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TranslateModule} from '@ox/translate';
import {TakataDataService, TrackingModule, TrackingService} from '@ox/data';
import {BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {DrawerModalModule, GeneralModalModule, TextInputModule} from '@ox/ui';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TakataNotificationsComponent} from './takata-notifications';
import {TakataModalComponent} from './takata-modal';

export const TAKATA_ROUTES = [
  {
    path: '',
    component: TakataNotificationsComponent,
    outlet: 'webu-takata-stay-up-to-date'
  }
];

@NgModule({
  declarations: [TakataNotificationsComponent, TakataModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    TrackingModule,
    ModalModule,
    TextInputModule,
    DrawerModalModule,
    FormsModule,
    ReactiveFormsModule,
    GeneralModalModule
  ],
  providers: [
    BsModalRef,
    BsModalService,
    TakataDataService,
    TrackingService
  ],
  exports: [TakataModalComponent, TakataNotificationsComponent]
})
export class TakataModule {}
